import React from 'react';
import { Switch } from 'antd';
import { SwitchProps } from 'antd/lib/switch';

export { SwitchChangeEventHandler } from 'antd/lib/switch';
export { SwitchProps };

export default (props: SwitchProps) => <Switch {...props} />;
